export default __webpack_public_path__ + "static/end_2-630b93663f66fbf0c41e665fa2df4149.png";